/**
 * Aggregator: combines all per-area translation dictionaries.
 * Page-specific modules live in this folder for maintainability.
 */
import nav from "./nav";
import general from "./general";
import specialties from "./specialties";
import content from "./content";
import b2b from "./b2b";
import blog from "./blog";

const translations = {
  ...nav,
  ...general,
  ...specialties,
  ...content,
  ...b2b,
  ...blog,
};

export default translations;
